module.exports = __webpack_public_path__ + "fonts/BreeSerif-Regular.3efb03a.ttf";